import { Component, OnInit } from '@angular/core';
import { LineChartHandler } from './line-chart.handler.';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'sym-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
})
export class LineChartComponent extends LineChartHandler implements OnInit {
  constructor(public service: DashboardService) {
    super(service);
  }
}
